var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{ref:"dynamicInput",staticClass:"dynamic-input",attrs:{"controls-position":"right"},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}},model:{value:(_vm.cell.deadline),callback:function ($$v) {_vm.$set(_vm.cell, "deadline", $$v)},expression:"cell.deadline"}})
}
var staticRenderFns = []

export { render, staticRenderFns }